import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import axiosConfig from "../../axiosConfig";
import SwipeableViews from "react-swipeable-views";

import { makeStyles, useTheme } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import Chip from "@material-ui/core/Chip";
import WarningIcon from "@material-ui/icons/Warning";
import Grid from "@material-ui/core/Grid";
import CircularProgress from "@material-ui/core/CircularProgress";

import { MyResponsiveBar } from "../Charts/Barchart/barChart";
import MaterialUIPickers from "../Datepicker/Datepicker";
import { OpenAlertsPie } from "../Charts/PieAlertsOpen/PieAlertOpen";
import AllAlerts from "../Alerts/AllAlerts";
import * as alertTypes from "../../shared/language.json";
import { Card, CardHeader, CardBody, CardFooter, } from "../../shared/Card/Index";
import styles from "../../shared/dashboardStyle";
import { CardContent, } from "@material-ui/core";

import "./VerticalTabForStatsCharts.css";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}
const useStyles2 = makeStyles(styles);

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "white",
    width: "100%",
    margin: "auto",
    marginTop: "2.5%",
  },
  tabs: {
    width: "100%",
    backgroundColor: "white",
  },
}));

export const AlarmStats = () => {
  const classes = useStyles();
  const classes2 = useStyles2();

  const theme = useTheme();
  const [value, setValue] = useState(0);
  const [openData, setOpenData] = useState("");
  const [statusData, setStatusData] = useState("");
  const [barData, setBarData] = useState("");
  const [allAlarms, setAllAlarms] = useState("");

  let currentDate = new Date();
  currentDate.setDate(currentDate.getDate() - 14);

  const [dateFrom, setDateFrom] = useState(currentDate.toISOString().slice(0, 10));
  const [dateTo, setDateTo] = useState(new Date().toISOString().slice(0, 10));

  useEffect(() => {
    datesSubmit();
  }, []);

  const fetchAllAlarms = () => {
    axiosConfig
      .get(
        `/Alarm/AlarmsByStatusIdAndDate?dateFrom=${dateFrom}&dateTo=${dateTo}`
      )
      .then((res) => {
        setAllAlarms(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };


  const fetchBarData = () => {
    let data;
    axiosConfig
      .get(`/AlarmStatistics/GetAlarmsPerTypeCount?dateFrom=${dateFrom}&dateTo=${dateTo}`)
      .then((res) => {
        const dataOnAlarmStats = res.data.map((d) => {
          if (d.description === alertTypes.ALERTSBARDATA.HEARTRATE) {
            return {
              ...d,
              label: alertTypes.ALERTSBARDATA.HEARTBEATS,
            };
          } else if (d.description === alertTypes.ALERTSBARDATA.BLOODPRESSURE) {
            return {
              ...d,
              label: alertTypes.ALERTSBARDATA.DIASTOLICPRESSURE,
            };
          } else if (
            d.description === alertTypes.ALERTSBARDATA.HIGHBLOODPRESSURE
          ) {
            return {
              ...d,
              label: alertTypes.ALERTSBARDATA.SYSTOLICPRESSURE,
            };
          } else if (d.description === alertTypes.ALERTSBARDATA.OXYGEN) {
            return {
              ...d,
              label: alertTypes.ALERTSBARDATA.SPO2,
            };
          } else if (d.description === "Άνοια") {
            return {
              ...d,
              label: ""
            }
          }
          else
            return {
              ...d,
              label: d.description,
            };
        });

        setBarData(dataOnAlarmStats);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchStatusData = () => {
    axiosConfig
      .get(
        `/AlarmStatistics/GetAlarmsPerStatusCount?dateFrom=${dateFrom}&dateTo=${dateTo}`
      )
      .then((res) => {
        if (res.data.length !== 0) {
          res.data[0]["color"] = "#03A9F4";
          res.data[1]["color"] = "#0288D1";
          res.data[2]["color"] = "#01579B";
        }
        setStatusData(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchOpenData = () => {
    axiosConfig
      .get(`/AlarmStatistics/GetAlarmsPerSeverityCount?dateFrom=${dateFrom}&dateTo=${dateTo}`)
      .then((res) => {
        if (res.data.length !== 0) {
          res.data[0]["color"] = "#03A9F4";
          res.data[1]["color"] = "#0288D1";
          res.data[2]["color"] = "#01579B";
        }
        setOpenData(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };


  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  const handleDateChangeFinal = (date) => {
    if (date) {
      setDateTo(date.toISOString().slice(0, 10))
      let previousDate = date.setDate(date.getDate() - 14)
      setDateFrom((new Date(previousDate)).toISOString().slice(0, 10))
    }
  }

  const datesSubmit = (e) => {
    fetchBarData();
    fetchStatusData();
    fetchOpenData();
    fetchAllAlarms();
  };

  const colAlertType = [
    {
      field: "alarmSeverity",
      title: "Δείκτης Κινδύνου",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
    {
      field: "alarmType",
      title: "Τύπος Ειδοποίησης",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
      defaultGroupOrder: 0,
    },
    {
      field: "dateCreated",
      title: alertTypes.LABELS.DATEALERT,
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
    {
      field: "statusDescription",
      title: "Κατάσταση",
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
    {
      field: "assignmentDate",
      title: "Ημ/νία Ανάληψης",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
    {
      field: "closureDate",
      title: "Ημ/νία Κλεισίματος",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
    {
      field: "assignmentUser",
      title: "Χειριστής Αν.",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
    {
      field: "closureUser",
      title: "Χειριστής Κλ.",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
  ];

  const colAlertSeverity = [
    {
      field: "alarmSeverity",
      title: "Δείκτης Κινδύνου",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
      defaultGroupOrder: 0,
    },
    {
      field: "alarmType",
      title: "Τύπος Ειδοποίησης",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
    {
      field: "dateCreated",
      title: alertTypes.LABELS.DATEALERT,
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
    {
      field: "statusDescription",
      title: "Κατάσταση",
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
    {
      field: "assignmentDate",
      title: "Ημ/νία Ανάληψης",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
    {
      field: "closureDate",
      title: "Ημ/νία Κλεισίματος",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },

    {
      field: "assignmentUser",
      title: "Χειριστής Αν.",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
    {
      field: "closureUser",
      title: "Χειριστής Κλ.",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
  ];

  const colAlertStatus = [
    {
      field: "alarmSeverity",
      title: "Δείκτης Κινδύνου",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
    {
      field: "alarmType",
      title: "Τύπος Ειδοποίησης",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
    {
      field: "dateCreated",
      title: alertTypes.LABELS.DATEALERT,
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
    {
      field: "statusDescription",
      title: "Κατάσταση",
      defaultGroupOrder: 0,
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      }
    },
    {
      field: "assignmentDate",
      title: "Ημ/νία Ανάληψης",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
    {
      field: "closureDate",
      title: "Ημ/νία Κλεισίματος",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
    {
      field: "assignmentUser",
      title: "Χειριστής Αν.",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
    {
      field: "closureUser",
      title: "Χειριστής Κλ.",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
  ];

  return (
    <div className={classes.root}>
      <Card>
        <CardHeader color="warning">
          <h1 className={classes2.cardTitleWhite}>Στατιστικά Ειδοποιήσεων</h1>
        </CardHeader>
        <CardBody>
          <MaterialUIPickers
            initialDate={dateFrom}
            finalDate={dateTo}
            handleDateChangeFinal={handleDateChangeFinal}
            datesSubmit={datesSubmit}
          />
        </CardBody>
        <CardFooter>
          <Tabs
            className={classes.tabs}
            value={value}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
            aria-label="full width tabs example"
          >
            <Tab label="Ειδοποιησεις ανα τυπο" {...a11yProps(0)} />
            <Tab label="Ειδοποιησεις Ανα Δεικτη Κινδυνου" {...a11yProps(1)} />
            <Tab label=" Ειδοποιησεις Ανα Κατασταση" {...a11yProps(2)} />
          </Tabs>
        </CardFooter>
      </Card>
      <SwipeableViews
        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
        index={value}
        onChangeIndex={handleChangeIndex}
      >
        {/* Λίστα ειδοποιήσεων ανά τύπο */}
        <TabPanel value={value} index={0} dir={theme.direction}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={12}>
              <Card>
                <CardContent>
                  <Box height={300} position="relative">
                    {barData !== [] && barData !== "" ? (
                      <MyResponsiveBar origin="Type" data={barData} />
                    ) : (
                      <CircularProgress></CircularProgress>
                    )}
                  </Box>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <AllAlerts data={allAlarms} col={colAlertType} />
            </Grid>
          </Grid>
        </TabPanel>

        {/* Λίστα ειδοποιήσεων ανά ρίσκο κινδύνου */}
        <TabPanel value={value} index={1} dir={theme.direction}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={12}>
              {openData !== [] && openData !== "" ? (
                <OpenAlertsPie data={openData} />
              ) : (
                <CircularProgress></CircularProgress>
              )}
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <AllAlerts data={allAlarms} col={colAlertSeverity} />
            </Grid>
          </Grid>
        </TabPanel>

        {/* Λίστα ειδοποιήσεων ανά status */}
        <TabPanel value={value} index={2} dir={theme.direction}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={12}>
              {statusData !== [] && statusData !== "" ? (
                <OpenAlertsPie statusData={statusData} />
              ) : (
                <CircularProgress></CircularProgress>
              )}
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <AllAlerts data={allAlarms} col={colAlertStatus} />
            </Grid>
          </Grid>
        </TabPanel>

      </SwipeableViews>
    </div>
  );
};